/* eslint-disable */

import axios from 'axios';
import root from '../_helpers/roots';

let eventListApiUrl = root.eventListApiUrl.link;
let eventInfoApiUrl = root.eventInfoApiUrl.link;


export default {
  state: {
  },
  mutations: {
  },
  actions: {
    eventListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(eventListApiUrl).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    eventInfoByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(eventInfoApiUrl + payload.id + '/').then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
  }
}